import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const menuItems = [
    { label: '首頁', path: '/', icon: 'ri-home-line' },
    { label: '抱樹好處', path: '/benefits', icon: 'ri-leaf-line' },
    { label: '如何好好抱樹', path: '/steps', icon: 'ri-hand-heart-line' },
    { label: '選擇一棵樹將情緒交比佢', path: '/mood-match', icon: 'ri-heart-3-line' },
    { label: '生活有啲攰？入嚟抱抱自己', path: '/daily-wisdom', icon: 'ri-sparkling-line' },
    { label: '在香港森林浴', path: '/forest-bathing', icon: 'ri-tree-line' },
    { label: '網誌', path: '/blog', icon: 'ri-article-line' },
    { label: '關於我哋', path: '/about', icon: 'ri-information-line' },
  ];

  const dividerIndex = 4; // after "生活有啲攰？入嚟抱抱自己"

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        {/* Left: hamburger menu */}
        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="relative w-10 h-10 flex items-center justify-center rounded-full bg-background-100/80 hover:bg-background-200 text-foreground-500 transition-colors cursor-pointer"
          aria-label="目錄"
        >
          <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>

        {/* Center: logo - delicate sans-serif, high-end minimalist */}
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="font-body text-base md:text-lg font-normal text-foreground-800 tracking-[0.15em] uppercase">
            1mindlab
          </span>
        </button>

        {/* Right: IG */}
        <a
          href="https://instagram.com/1mindlab"
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100/80 hover:bg-accent-500 hover:text-background-50 text-foreground-500 transition-colors cursor-pointer"
          aria-label="Instagram @1mindlab"
        >
          <i className="ri-instagram-line text-lg"></i>
        </a>
      </div>

      {/* Dropdown menu - refined Japanese style */}
      {menuOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)}></div>
          <nav className="absolute top-full left-4 md:left-10 mt-2 w-60 bg-background-50 rounded-3xl border border-background-200/70 shadow-sm py-3 z-50">
            <div className="px-5 py-2 text-[10px] tracking-[0.25em] uppercase text-foreground-400 font-semibold">
              目錄
            </div>
            {menuItems.map((item, idx) => (
              <>
                {idx === dividerIndex + 1 && (
                  <div key="divider" className="mx-5 my-1 h-px bg-background-200/80"></div>
                )}
                <button
                  key={item.path}
                  type="button"
                  onClick={() => {
                    navigate(item.path);
                    setMenuOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-5 py-3 text-sm font-medium transition-colors cursor-pointer ${
                    location.pathname === item.path
                      ? 'text-primary-600 bg-primary-50/80'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${item.icon} text-base w-5 flex items-center justify-center`}></i>
                  <span className="whitespace-nowrap">{item.label}</span>
                </button>
              </>
            ))}
          </nav>
        </>
      )}
    </header>
  );
}